export default __webpack_public_path__ + "static/media/play_new_exp.288fc176.svg";